import React from 'react';
import styled from 'styled-components';
import { VideoExtensionType } from '@contracts';

interface Props {
  mp4: any;
  cover?: boolean;
  width?: number;
  height?: number;
  placeholder?: string;
  id?: string;
  autoplay?: boolean;
  type?: VideoExtensionType;
  controls?: boolean;
  loop?: boolean;
  muted?: boolean;
}

export default function Video({
  id = '',
  mp4,
  placeholder,
  cover = false,
  width = 1920,
  height = 1080,
  autoplay = true,
  controls = false,
  type = VideoExtensionType.MP4,
  loop = true,
  muted = true
}: Props) {
  const aspectRatioPadding = 100 / (width / height);

  return (
    <Container $cover={cover} className="video-container">
      <VideoWrapper className="video-wrapper" $aspectRatioPadding={aspectRatioPadding}>
        <video
          id={id}
          width={width}
          height={height}
          poster={placeholder}
          controls={controls}
          autoPlay={autoplay}
          loop={loop}
          muted={muted}
          playsInline
        >
          <source src={mp4} type={`video/${type}`} />
        </video>
      </VideoWrapper>
    </Container>
  );
}

interface IContainer {
  $cover?: boolean;
}

const Container = styled.div<IContainer>`
  z-index: 1;

  ${({ $cover }) => {
    if ($cover) {
      return `
      position: relative;
      height: 100vh;
      height: -webkit-fill-available;
      
      .video-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    overflow: hidden;
    padding: 0;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    z-index: 0;
  }
      `;
    }
    return ``;
  }}
`;

interface IVideoWrapper {
  $aspectRatioPadding: number;
}

const VideoWrapper = styled.div<IVideoWrapper>`
  position: relative;
  z-index: 2;
  padding-bottom: ${(props) => (props.$aspectRatioPadding ? props.$aspectRatioPadding : 48.25)}%;
  height: 0;

  & > video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: none;
  }
`;
